import React from "react";
import TableList from "../../Components/tableList/TableList";
import Api from "../../services/api";
import "../Prelude/prelude.css";
import "../../Components/reports/reports.css";
import InputReport from "../../Components/inputReport/inputReport";
import "../../Components/inputReport/inputReport.css";
import moment from "moment";
import MessageTable from "../../Components/messageTable/MessageTable";
import DatePicker from "../../Components/datePicker/datePicker";
import ExcelButton from "../../Components/exportExcelButton/ExportExcelButton";
import "./generalReports.css";
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";
//import BottomBar from "../../Components/bottomBar/bottomBar";
import Button from '../../Components/commonButton/commonButton';
import Select from '../../Components/select/select';
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faFilter } from "@fortawesome/free-solid-svg-icons";
import FilterBox from "../../Components/filterBox/filterBox";

class reportAndon extends React.Component {
  state = {
    text: "",
    data: [],
    initialData: [],
    code: null,
    reasons: [],
    machine: "",
    item: "",
    start_date: new Date().toLocaleDateString('pt-BR'),
    end_date: new Date().toLocaleDateString('pt-BR'),
    reason: "",
    level: "",
    levels: [
      { value: "Insp./Prep./Ferram.", label: "Insp./Prep./Ferram." },
      { value: "Supervisor", label: "Supervisor" },
      { value: "Coordenador", label: "Coordenador" },
      { value: "Gerente", label: "Gerente" },
      { value: "Diretor", label: "Diretor" },
    ],
    loading: false,
  };

  changeValueCode = (data) => {
    const { id } = this.state.arr_idcodes.find(value => value.id === data)
  }

  changeValueCodeLevel = (data) => {
    const { id } = this.state.levels.find(level => level.value === data)
  }

  componentDidMount() {
    Api.get("/reasons-stop")
      .then((resp) => {
        let arr_codes = []
        let arr_ids = []
        let dataFiltered = resp.data.response.filter((v) => v.tracking);
        let arr = [];
        dataFiltered.forEach((element) => {

          arr_codes.push({ value: element.code, label: element.code + " - " + element.description });
          arr_ids.push({ id: element.code, code: element.description });
        });
        this.setState({ reasons: arr_codes, arr_idcodes: arr_ids });
        if (this.state.loading) this.setState({ loading: false });
      })
      .catch((error) => {
      });
  }

  sendData = async () => {
    const params = {
      machine: this.state.machine,
      item: this.state.item,
      reason: this.state.reason,
      level: this.state.level,
      dt_ini: this.state.start_date,
      dt_end: this.state.end_date
    }
    let count = 0
    for (let p in params) {
      if (params[p])
        count++
    }
    if (count > 0) {
      this.setState({ loading: true })
      await Api.get("/reports/andon-resolution/", { params: params })
        .then((resp) => {
          let arr = [];
          if (resp.data.length === 0) {
            this.setState({ render: false,loading: false });
          } else {
            resp.data.forEach((element) => {
              arr.push({
                Máquina: element.Máquina,
                Ordem: element.Ordem,
                Item: element.Item,
                Boleta: element.measure === "" ? "- - -" : element.measure,
                Operador: element.Operador,
                Data: moment(element.Data).format("DD/MM/YYYY"),
                Início: element.Início,
                Fim: element.Fim,
                Tempo: element.Tempo,
                ["H. Desbloqueio"]: element["H. Desbloqueio"],
                Motivo: element.Motivo,
                ["Não Conform."]: element["Não Conform."],
                Ação: element["Ação"],
                Turno: element.Turno,
                Nível: element.Nível,
              });
            });
            this.setState({ data: arr, render: true, initialData: arr });
            if (this.state.loading) this.setState({ loading: false });
          }
        })
        .catch((err) => {
          alert("Erro de conexão com o servidor");
        });
    } else {
      alert("Preencha um campo de filtro");
    }
  }

  filterReason = (data) => {
    let { value, name } = data;
    this.setState({ [`${name}`]: value });
    /* let result = this.state.initialData.filter(
      (v) => v[name].indexOf(value.substring(0, 2)) > -1
    ); */

    /* if (result.length > 0) {
      this.setState({ data: result });
    } else {
      this.setState({ data: this.state.initialData });
    } */
  };

  saveText = (data) => {
    const { value, name } = data;
    this.setState({ [`${name}`]: value });
    /* this.filter(value, name); */
  };

  filterData = (data, name) => {
    this.setState({ [`${name}`]: data });
  };

  excelbutton = (event) => {
    if (this.state.data.length === 0) {
      alert("Preencha um campo de filtro")
      event.preventDefault()
    }
  }

  render() {
    let keys = null;
    const Row = ({ record }) => {
      const keys = Object.keys(record);
      return (
        <tr key={record.id}>
          {keys.map((key) => (
            <>
              {key === "Motivo" ?
                <td key={key}>{record[key]}</td> :
                <td key={key}>{record[key]}</td>
              }
            </>
          ))}
        </tr>
      );
    };

    if (this.state.render) {
      keys = Object.keys(this.state.data[0]);
    }

    return (
      < >
        <div className="filters boxReport">
          <FilterBox title="Filtros">
            <div className="elementFilter" type="input">
              <InputReport
                name="machine"
                parentCallback={this.saveText}
                title="Máquina"
                focus={true}
              />
            </div>
            <div className="elementFilter" type="input">
              <InputReport
                name="item"
                parentCallback={this.saveText}
                title="Item"
              />
            </div>
            <div className="elementFilter" type="input">
              <DatePicker
                name="start_date"
                title="Data"
                parentCallback={(e) => this.filterData(e, "start_date")}
              ></DatePicker>
            </div>
            <div className="elementFilter" type="input" id="filterSelect">
              <Select label="Motivo" arrData={this.state.reasons} handleSelect={this.changeValueCode} />
            </div>
            <div className="elementFilter" type="input" id="filterSelect">
              <Select label="Nível" arrData={this.state.levels} handleSelect={this.changeValueCodeLevel} />
            </div>
            <div className="buttonFilter" type="button">
              <ExcelButton onClick={this.excelbutton}
                data={this.state.data}
                filename={`andon_${moment()
                  .utc()
                  .utcOffset("-03:00")
                  .format("DDMMYY_HHmmss")}.csv`}
              />
            </div>
            <div className="buttonFilter" type="button">
              <Button size title="Gerar" icon="faGear" parentCallback={this.sendData} />
            </div>
          </FilterBox>
          {this.state.loading ? (
            <div className="TableReport">
              <div style={{ marginTop: '20vh' }} className={styles.loader}>
                <Spinner variant="success" animation="border" />
                <strong>Carregando...</strong>
              </div>
            </div>
          ) : (
            <>
              {this.state.render ? (
                <div className="TableReport">
                  <TableList data={this.state.data}></TableList>
                </div>
              ) : (
                <div className="TableReport">
                  <MessageTable message={"Sem dados para processar."} />
                </div>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}
export default reportAndon;